// https://km.sankuai.com/collabpage/2558407965
import { getStrategy } from '@m2h/common/webApi/abStrategy';

const SLABStrategy = {
  hitGoldenStrategy() {
    // return false;
    return true;
  },
  hitGlobalV3() {
    return getStrategy({
      sceneKey: 'global_app',
      groupKey: 'global_app_v3',
    })?.expKey === 'A';
  },
  getStrategy,
  getRealTimeStrategy: getStrategy,
  getHeaderStrategy() {
    return getStrategy();
  },
};

export default SLABStrategy;
